import { RootState } from '@reducers';

export const selectHealthQuoteComparePage = (state: RootState) => state.healthQuoteComparePageReducer;
